const Component = () => import('./Registration');

export { Component };
